import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { use, useEffect, useState } from "react";
import { UserRole } from "../../enums";
import UnAuthorized from "./UnAuthorized";

export default function Protected({
    path,
  roles,
  children,
}: {
  children: any;
  roles:UserRole[]
    path: string;
}) {
  const { user, ready } = useAuth(); 
  const navigate = useNavigate();
  const [isAuthorized, setIsAuthorized] = useState<boolean|undefined>(undefined);

  useEffect(() => {
    const isAuthorized =user? roles.includes(user.role):undefined; 
    setIsAuthorized(isAuthorized);
  }, [user]);

  if (ready === false) {
    return (
      <div className="flex justify-center items-center h-screen text-lg">
        Loading...
      </div>
    );
  } else {
    if (isAuthorized === true) return children;
    else if (isAuthorized === false || !user) {
      navigate(`/unAuthorized?callbackUrl=${path}`);
      return <div></div>
    }
  }
}
